import englishIcon from "../assets/icons/english.png";
import germanyIcon from "../assets/icons/germany.png";
import spainIcon from "../assets/icons/spain.png";
import franceIcon from "../assets/icons/france.png";

export const langDrpData = [
    {
        lang: "English",
        img: englishIcon,
        selected: false,
    },
    {
        lang: "German",
        img: germanyIcon,
        selected: false,
    },
    {
        lang: "Spanish",
        img: spainIcon,
        selected: false,
    },
    {
        lang: "French",
        img: franceIcon,
        selected: false,
    },
];